
import React, { Fragment, Component } from 'react';
import { Container, Row, Col, Carousel, Jumbotron, Button } from 'react-bootstrap';
import { Redirect } from 'react-router-dom';
import logo from '../assets/images/oneroof-logo.svg';

import Countdown from 'react-countdown';
// import * as actions from '../store/actions/index'
import Nav from 'react-bootstrap/Nav';
import Helmet from "react-helmet";

import SecondaryCarousel from '../component/SecondaryCarousel/SecondaryCarousel'
import ThirdCarousel from '../component/ThirdCarousel/ThirdCarousel'


import * as actions from '../store/actions/index';
import { connect } from 'react-redux';


class Main extends Component {
    state = {
        SecondaryRowMenu: ["Limited Time Deals", "People also view", "Trending Products"],
        activeMenu: '',
        activeSubMenu: false

    }
    constructor(props) {
        super(props)

    }




    componentDidMount() {
    }

    HandleSecondaryChange = (dataName) => {
        // console.log(dataName)
    }

    render() {


        const { SecondaryRowMenu, activeMenu } = this.state

        // Random component
        const Completionist = () => <span>You are good to go!</span>;

        // Renderer callback with condition
        const renderer = ({ hours, minutes, seconds, completed }) => {
            if (completed) {
                // Render a completed state
                return <Completionist />;
            } else {
                // Render a countdown
                return <span>{hours}:{minutes}:{seconds}</span>;
            }
        };



        return (

            <Fragment>
                <Helmet>
                    <title>One Roof</title>
                    <meta name="description" content="Furiture" />
                    <meta name="theme-color" content="#008f68" />
                </Helmet>
                <Row className="m-0">
                    <Col md={12} className="p-0">
                        <Carousel>
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src="./images/banner1.jpg"
                                    alt="First slide"
                                />

                            </Carousel.Item>
                            <Carousel.Item>
                                <img
                                    className="d-block w-100"
                                    src="./images/banner2.jpg"
                                    alt="Third slide"
                                />
                            </Carousel.Item>

                        </Carousel>
                    </Col>
                </Row>
                <Container>
                    <Row className="pt-4 secondarycarousel">
                        <Col md={12}>
                            <div className="d-flex justify-content-between mb-3" >
                                <Col className="col-6 mr-auto ml-auto">
                                    <Nav fill variant="tabs">
                                        {
                                            SecondaryRowMenu.map((d, i) => (
                                                <Nav.Item key={i}>
                                                    <Nav.Link className={activeMenu == i ? "active-secondary" : ""} onClick={() => this.HandleSecondaryChange(d)}>{d}</Nav.Link>
                                                </Nav.Item>

                                            ))
                                        }
                                    </Nav>
                                </Col>
                            </div>
                            <SecondaryCarousel />
                        </Col>
                    </Row>
                </Container>
                <Jumbotron style={{ backgroundImage: `url(../images/banner1.jpg)`, backgroundSize: 'cover', backgroundPosition: 'center' }} className="mt-4 mb-0">

                </Jumbotron>
                <div className="gray-bg">
                    <Container className="">

                        <Row className="secondarycarousel">
                            <Col md={12} className="text-center pt-4">
                                <h2>Weekly BestSellers</h2>
                                <ThirdCarousel
                                />
                            </Col>
                        </Row>

                        <Row className="text-center pt-4 secondarycarousel">
                            <Col md={12}>
                                <h2>Weekly BestSellers</h2>
                                <ThirdCarousel
                                />
                            </Col>
                        </Row>




                    </Container>
                </div>
                <Container className="pt-4 bg-white">


                    <Row className="mt-4">
                        <Col md={4}>
                            <img
                                className="d-block w-100"
                                src="./images/livingroomset.png"
                                alt="Third slide"
                            />
                        </Col>

                        <Col md={4}>
                            <Row>
                                <Col sm={12}>
                                    <img
                                        className="d-block w-100"
                                        src="./images/bedset.png"
                                        alt="Third slide"
                                    />
                                </Col>
                            </Row>
                            <Row className="pt-5">
                                <Col sm={12}>
                                    <img
                                        className="d-block w-100"
                                        src="./images/gardenset.png"
                                        alt="Third slide"
                                    />
                                </Col>
                            </Row>

                        </Col>
                        <Col md={4}>
                            <img
                                className="d-block w-100"
                                src="./images/livingroomset.png"
                                alt="Third slide"
                            />
                        </Col>

                    </Row>

                    {/* <div className="mt-5 d-flex justify-content-between">
                    <div >
                            <img
                                className="d-block"
                                src="https://dummyimage.com/150x67/"
                                alt="First slide"
                            />

                        </div>   
                        <div >
                            <img
                                className="d-block"
                                src="https://dummyimage.com/150x67/"
                                alt="First slide"
                            />

                        </div>    
                        <div >
                            <img
                                className="d-block"
                                src="https://dummyimage.com/150x67/"
                                alt="First slide"
                            />

                        </div>    
                        <div >
                            <img
                                className="d-block"
                                src="https://dummyimage.com/150x67/"
                                alt="First slide"
                            />

                        </div>  
                        <div >
                            <img
                                className="d-block"
                                src="https://dummyimage.com/150x67/"
                                alt="First slide"
                            />

                        </div>      
                        <div >
                            <img
                                className="d-block"
                                src="https://dummyimage.com/150x67/"
                                alt="First slide"
                            />

                        </div>              

                </div> */}

                </Container>
            </Fragment>
        )
    }

}

const mapStateToProps = (state) => ({
    show: state.modal.show,
    showModalName: state.modal.name,
    step: state.modal.step
})
// export default Main

export default connect(mapStateToProps)(Main);